import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { useElementInteracted } from '@repo/platform-analytics/hooks/useElementInteracted';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
type TooltipActionType = 'open' | 'close';
const getAnalyticsDriverActionName = (driverLabel: string) => {
  return `quick_fact_value_tooltip_${driverLabel.toLowerCase().split(' ').join('')}`;
};
export function useMonetizingTooltipPageAction() {
  const $ = _c(7);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      actionName: "",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[2] !== skuImpressionId) {
    t1 = {
      entityName: "",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[2] = skuImpressionId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fireElementInteracted = useElementInteracted(t1);
  let t2;
  if ($[4] !== fireElementInteracted || $[5] !== firePageAction) {
    t2 = (driverLabel, actionType, actionSection) => {
      firePageAction({
        action_name: `${getAnalyticsDriverActionName(driverLabel)}`,
        action_type: actionType,
        action_section: actionSection
      });
      fireElementInteracted({
        entity_name: getAnalyticsDriverActionName(driverLabel),
        interaction_type: actionType,
        section_name: actionSection
      });
    };
    $[4] = fireElementInteracted;
    $[5] = firePageAction;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function useNonMonetizingTooltipPageAction(offerId) {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function getAnalyticsDriverActionName(driverLabel) {
      return `quick_fact_value_tooltip_${driverLabel.toLowerCase().split(" ").join("")}`;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const getAnalyticsDriverActionName = t0;
  let t1;
  if ($[1] !== offerId) {
    t1 = {
      actionName: "",
      additionalAttributes: {
        sku_id: offerId
      }
    };
    $[1] = offerId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const firePageAction = usePageAction(t1);
  let t2;
  if ($[3] !== offerId) {
    t2 = {
      entityName: "",
      additionalAttributes: {
        sku_id: offerId
      }
    };
    $[3] = offerId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const fireElementInteracted = useElementInteracted(t2);
  let t3;
  if ($[5] !== fireElementInteracted || $[6] !== firePageAction) {
    t3 = (driverLabel_0, actionType, actionSection) => {
      firePageAction({
        action_name: `${getAnalyticsDriverActionName(driverLabel_0)}`,
        action_type: actionType,
        action_section: actionSection
      });
      fireElementInteracted({
        entity_name: getAnalyticsDriverActionName(driverLabel_0),
        interaction_type: actionType,
        section_name: actionSection
      });
    };
    $[5] = fireElementInteracted;
    $[6] = firePageAction;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}